var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},_vm._l((_vm.imgUrl),function(item,index){return _c('div',{key:index},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }